{
  "TrialBalanceMultipleEntities": {
    "Standard": {
      "TableStructureType": "TrialBalanceMultipleEntities",
      "FieldItems": [
        {
          "Title": "Entity Code Row",
          "Key": "EntityCodeRow",
          "CamelCaseKey": "entityCodeRow",
          "Type": "Row"
        },
        {
          "Title": "Entity Name Row",
          "Key": "EntityNameRow",
          "CamelCaseKey": "entityNameRow",
          "Type": "Row",
          "IsOptional": true
        },
        {
          "Title": "Account Code Column",
          "Key": "AccountCodeColumn",
          "CamelCaseKey": "accountCodeColumn",
          "Type": "Col"
        },
        {
          "Title": "Account Name Column",
          "Key": "AccountNameColumn",
          "CamelCaseKey": "accountNameColumn",
          "Type": "Col",
          "IsOptional": true
        },
        {
          "Title": "Currency Row",
          "Key": "CurrencyRow",
          "CamelCaseKey": "currencyRow",
          "Type": "Row",
          "IsOptional": true
        },
        {
          "Title": "Data Start Row",
          "Key": "StartDataRow",
          "CamelCaseKey": "startDataRow",
          "Type": "Row"
        },
        {
          "Title": "Data Start Column",
          "Key": "DataStartColumn",
          "CamelCaseKey": "dataStartColumn",
          "Type": "Col"
        }
      ]
    },
    "Transposed": {
      "TableStructureType": "TrialBalanceMultipleEntitiesTransposed",
      "FieldItems": [
        {
          "Title": "Entity Code Column",
          "Key": "EntityCodeColumn",
          "CamelCaseKey": "entityCodeColumn",
          "Type": "Col"
        },
        {
          "Title": "Entity Name Column",
          "Key": "EntityNameColumn",
          "CamelCaseKey": "entityNameColumn",
          "Type": "Col",
          "IsOptional": true
        },
        {
          "Title": "Account Code Row",
          "Key": "AccountCodeRow",
          "CamelCaseKey": "accountCodeRow",
          "Type": "Row"
        },
        {
          "Title": "Account Name Row",
          "Key": "AccountNameRow",
          "CamelCaseKey": "accountNameRow",
          "Type": "Row",
          "IsOptional": true
        },
        {
          "Title": "Currency Column",
          "Key": "CurrencyColumn",
          "CamelCaseKey": "currencyColumn",
          "Type": "Col",
          "IsOptional": true
        },
        {
          "Title": "Data Start Row",
          "Key": "StartDataRow",
          "CamelCaseKey": "startDataRow",
          "Type": "Row"
        },
        {
          "Title": "Data Start Column",
          "Key": "DataStartColumn",
          "CamelCaseKey": "dataStartColumn",
          "Type": "Col"
        }
      ]
    },
    "Source": "TrialBalance"
  },
  "TrialBalanceStandard": {
    "Standard": {
      "TableStructureType": "TrialBalanceStandard",
      "FieldItems": [
        {
          "Title": "Entity Code Column",
          "Key": "EntityCodeColumn",
          "CamelCaseKey": "entityCodeColumn",
          "Type": "Col"
        },
        {
          "Title": "Entity Name Column",
          "Key": "EntityNameColumn",
          "CamelCaseKey": "entityNameColumn",
          "Type": "Col",
          "IsOptional": true
        },
        {
          "Title": "Account Code Column",
          "Key": "AccountCodeColumn",
          "CamelCaseKey": "accountCodeColumn",
          "Type": "Col"
        },
        {
          "Title": "Account Name Column",
          "Key": "AccountNameColumn",
          "CamelCaseKey": "accountNameColumn",
          "Type": "Col",
          "IsOptional": true
        },
        {
          "Title": "Currency Column",
          "Key": "CurrencyColumn",
          "CamelCaseKey": "currencyColumn",
          "Type": "Col",
          "IsOptional": true
        },
        {
          "Title": "Amount",
          "Key": "AmountColumn",
          "CamelCaseKey": "amountColumn",
          "Type": "Col"
        },
        {
          "Title": "Data Start Row",
          "Key": "StartDataRow",
          "CamelCaseKey": "startDataRow",
          "Type": "Row"
        }
      ]
    },
    "Source": "TrialBalance"
  },
  "Transaction": {
    "Standard": {
      "TableStructureType": "Transaction",
      "FieldItems": [
        {
          "Title": "Payor Entity Code Row",
          "Key": "PayorEntityCodeRow",
          "CamelCaseKey": "payorEntityCodeRow",
          "Type": "Row"
        },
        {
          "Title": "Payor Entity Code Column",
          "Key": "PayorEntityCodeColumn",
          "CamelCaseKey": "payorEntityCodeColumn",
          "Type": "Col"
        },
        {
          "Title": "Payor Entity Name Column",
          "Key": "PayorEntityNameColumn",
          "CamelCaseKey": "payorEntityNameColumn",
          "Type": "Col"
        },
        {
          "Title": "Payor Entity Type Column",
          "Key": "PayorEntityTypeColumn",
          "CamelCaseKey": "payorEntityTypeColumn",
          "Type": "Col"
        },
        {
          "Title": "Elimination Column",
          "Key": "EliminationColumn",
          "CamelCaseKey": "eliminationColumn",
          "Type": "Col"
        },
        {
          "Title": "Payment After Elim Column",
          "Key": "PaymentAfterElimColumn",
          "CamelCaseKey": "paymentAfterElimColumn",
          "Type": "Col"
        },
        {
          "Title": "Payee Entity Code Row",
          "Key": "PayeeEntityCodeRow",
          "CamelCaseKey": "payeeEntityCodeRow",
          "Type": "Row"
        },
        {
          "Title": "Payee Entity Code Column",
          "Key": "PayeeEntityCodeColumn",
          "CamelCaseKey": "payeeEntityCodeColumn",
          "Type": "Col"
        },
        {
          "Title": "Payee Entity Name Row",
          "Key": "PayeeEntityNameRow",
          "CamelCaseKey": "payeeEntityNameRow",
          "Type": "Row"
        },
        {
          "Title": "Payee Entity Type Row",
          "Key": "PayeeEntityTypeRow",
          "CamelCaseKey": "payeeEntityTypeRow",
          "Type": "Row"
        },
        {
          "Title": "Country Row",
          "Key": "CountryRow",
          "CamelCaseKey": "countryRow",
          "Type": "Row"
        },
        {
          "Title": "Data Start Row",
          "Key": "StartDataRow",
          "CamelCaseKey": "startDataRow",
          "Type": "Row"
        },
        {
          "Title": "Data Start Column",
          "Key": "DataStartColumn",
          "CamelCaseKey": "dataStartColumn",
          "Type": "Col"
        }
      ]
    },
    "Source": "Transaction"
  },
  "Matrix": {
    "Standard": {
      "TableStructureType": "Matrix",
      "FieldItems": [
        {
          "Title": "Header Row",
          "Key": "HeaderRow",
          "CamelCaseKey": "headerRow",
          "Type": "Row"
        },
        {
          "Title": "Header Column",
          "Key": "HeaderColumn",
          "CamelCaseKey": "headerColumn",
          "Type": "Col"
        },
        {
          "Title": "Data Start Row",
          "Key": "StartDataRow",
          "CamelCaseKey": "startDataRow",
          "Type": "Row"
        },
        {
          "Title": "Data Start Column",
          "Key": "DataStartColumn",
          "CamelCaseKey": "dataStartColumn",
          "Type": "Col"
        }
      ]
    },
    "Source": "Matrix"
  }
}
